import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

export class DepotsRequests {

  /* @ngInject */
  constructor(private depotsAPI: BringozApi, private $depots) {
  }

  // ******************************
  //        Public methods
  // ******************************

  createOne(data) {
    var api = this.depotsAPI.actions.createOne;
    return this.$$call(api, {}, data, {});
  }

  updateOne(depotId, data) {
    var api = this.depotsAPI.actions.updateOne;
    return this.$$call(api, {}, data, {id: depotId});
  }

  addBranchesToDepots(depotIds: string[], branchIds: string[]) {
    var api = this.depotsAPI.actions.addBranchesToDepots;
    return this.$$call(api, {}, {depotIds: depotIds, branchIds: branchIds}, {});
  }

  deleteDepot(depotId) {
    var api = this.depotsAPI.actions.deleteDepot;
    return this.$$call(api, {}, {}, {id: depotId});
  }


  // ******************************
  //        Private methods
  // ******************************


  $$call(_apiCall, _params, _data, _options) {
    return this.$depots().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.depots')
  .service('depotsRequests', DepotsRequests);
